import { useState, useEffect, useRef } from "react";
import "./MyShoppingCart.css";
import "./ShoppingCartBranch.css";
import {
  Truck,
  ArrowRight,
  Pencil,
  Trash2,
  Gift,
  Tag,
  X,
  ChevronDown,
  Package,
  Search,
} from "lucide-react";
import Breadcrums from "../../components/breadcrums_v2/Breadcrums";
import ApiService from "../../components/Api_services";
import EditCart from "../../components/editcart_v2/EditCart";
import { useNavigate } from "react-router-dom";
// import ReactDOM from "react-dom";
import FallbackImg from "../../components/FallbackImg";
import BadgePercent from "../../assets/icons/badge-percent.png";
import MultiPurpose from "../../components/multipurpose_v2/MultiPurpose";
import { useSelector } from "react-redux";
import { ACCESS_KEYS } from "../../constants";
import { hasAccess } from "../../utils/Permission";
import { BACKEND_URL } from "../../constants";
import { useContext } from "react";
import { TotalAmountContext } from "../../contexts/TotalAmountContext";

function getPagination(current, total) {
  const pages = [];
  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i);
  } else {
    pages.push(1);
    if (current > 4) pages.push("...");
    let start, end;
    if (current <= 4) {
      start = 2;
      end = 5;
    } else if (current >= total - 3) {
      start = total - 4;
      end = total - 1;
    } else {
      start = current - 1;
      end = current + 1;
    }
    for (let i = start; i <= end; i++) {
      if (i > 1 && i < total) pages.push(i);
    }
    if (current < total - 3) pages.push("...");
    pages.push(total);
  }
  return pages;
}

const MyShoppingCartv2 = ({
  fetchCounts,
  cartCount,
  cartByPricingTypeCount,
}) => {
  // State variables
  const [pricingTypes, setPricingTypes] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cartData, setCartData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedCsIds, setSelectedCsIds] = useState([]);
  const [selectedCsItemIds, setSelectedCsItemIds] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const [selectedTotals, setSelectedTotals] = useState({
    total_item: 0,
    subtotal: 0,
    discount: 0,
    total_shipping_cost: 0,
    total: 0,
  });
  const [showDeleteItem, setShowDeleteItem] = useState(false);
  const [deleteItem, setDeleteItem] = useState("");
  const [showPwpNotice, setShowPwpNotice] = useState(false);
  const [showReturnMessage, setShowReturnMessage] = useState(false);
  const [returnMessage, setReturnMessage] = useState("");
  const [showOrderListPopup, setShowOrderListPopup] = useState(false);
  const [orderListLoading, setOrderListLoading] = useState(false);
  const [orderListFetchedCart, setOrderListFetchedCart] = useState(null);
  const navigate = useNavigate();
  const [totalCartitemCountbyPricingType, setCartitemCountByPricingType] =
    useState([]);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [q_customer_id, setQCustomerId] = useState("");
  const [allMainCartItems, setAllMainCartItems] = useState([]);
  const [activeBranchItemId, setActiveBranchItemId] = useState(null);
  const [activePromoItemId, setActivePromoItemId] = useState(null);
  const [editCartItem, setEditCartItem] = useState(null);
  const [showEditCart, setShowEditCart] = useState(false);
  const skipCalculation = useRef(false);
  const skipSelectAllCheck = useRef(false);
  const [overdueMessage, setOverdueMessage] = useState("");
  const [showOverdueMessage, setShowOverdueMessage] = useState(false);
  const [creditLimitMessage, setCreditLimitMessage] = useState("");
  const [showCreditLimitMessage, setShowCreditLimitMessage] = useState(false);
  const [notice, setNotice] = useState({ show: false, message: "" });
  const [wishlistStatus, setWishlistStatus] = useState({});
  const [removeLoading, setRemoveLoading] = useState(false);

  const sub_role = useSelector((state) => state.auth.sub_role) || [];
  const is_subuser =
    useSelector((state) => state.auth.user?.is_subuser) || false;
  const canCheckout = !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_ORDER);
  const canView = !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_ORDER);

  // Fetch cart data
  useEffect(() => {
    if (activeTab === null) return;
    fetchCartData(1, activeTab, "");
  }, [activeTab]);

  useEffect(() => {
    ApiService.removeBuyNowCart();
  }, []);

  useEffect(() => {
    const fetchPricingType = async () => {
      try {
        const response = await ApiService.getPricingType();
        if (response && response.status === 200) {
          const data = response.data;
          if (Array.isArray(data)) {
            setPricingTypes(data);
            // Set default tab to first pricing_type if exists
            if (data.length > 0) setActiveTab(data[0].pricing_type);
          } else if (data) {
            setPricingTypes([data]);
            setActiveTab(data.pricing_type);
          } else {
            setPricingTypes([]);
            setActiveTab("");
          }
        }
      } catch (error) {
        console.error("Error fetching pricing type:", error);
        setPricingTypes([]);
        setActiveTab("");
      }
    };
    fetchPricingType();
  }, []);

  // const fetchCartCount = async () => {
  //   try {
  //     const response = await ApiService.getCartByPricingType();
  //     if (response && response.status === 200) {
  //       setTotalCartitemCount(response.data["Results Total Cart"]);
  //       setCartitemCountByPricingType(response.data.by_pricing_type);
  //       // console.log("pricingtype", totalCartitemCountbyPricingType);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching cart item count:", error);
  //   }
  // };

  const processCartItems = (cartItems) => {
    if (!cartItems || !Array.isArray(cartItems)) return [];

    const itemGroups = {};

    cartItems.forEach((item) => {
      // Package items: keep each as its own row (don't merge by item_id)
      // const key =
      //   item.is_package === 1
      //     ? `pkg_${item.id}`
      //     : `${item.item_id}_${item.is_foc}}`;
      let key;
      if (item.is_package === 1) {
        key = `pkg_${item.id}`;
      } else if (item.quotation_id && item.quotation_id !== "") {
        // Quotation items — always keep as separate row per cart id
        key = `quotation_${item.id}`;
      } else if (item.is_support_item) {
        key = `support_${item.id}`;
      } else {
        key = `${item.id}`;
      }

      if (!itemGroups[key]) {
        itemGroups[key] = {
          ...item,
          originalIds: [item.id],
        };
      } else {
        if (!itemGroups[key].originalIds.includes(item.id)) {
          itemGroups[key].originalIds.push(item.id);
        }
      }
    });

    return Object.values(itemGroups);
  };

  // Function to fetch cart data based on pricing type
  const fetchCartData = async (page = 1, activeTab, searchTerm = "") => {
    setLoading(true);
    try {
      const response = await ApiService.getMyCart(
        page,
        activeTab,
        itemsPerPage,
        searchTerm,
      );

      if (response.status === 200) {
        // Extract customer_id from the response and store in state
        try {
          const cartDataResults = response.data?.results;
          // Prefer customer_id on the results object, fallback to first cart item's customer_id
          let customerId =
            (cartDataResults && cartDataResults.customer_id) || null;
          if (
            !customerId &&
            Array.isArray(cartDataResults?.cart) &&
            cartDataResults.cart.length > 0
          ) {
            customerId = cartDataResults.cart[0].customer_id || null;
          }
          if (customerId) {
            setQCustomerId(String(customerId));
          }
        } catch (err) {
          // ignore extraction errors
        }
        if (response.data?.results?.cart) {
          // Group items by item_id
          const processedItems = processCartItems(response.data.results.cart);

          // PRECOMPUTE branch data for each item
          const processedWithBranchData = processedItems.map((item) => {
            const promoTags = getPromotionTags([
              item,
              ...(item.children || []),
            ]);
            const promotionTypes = promoTags.map((tag) => tag.type);
            const offerTypes = promoTags.map((tag) => tag.offerType);

            const branchesToRender = [];

            // Find all Buy X Free Y tags (type 4)
            const buyXFreeYTags = promoTags.filter(
              (tag) => tag.type === 4 && tag.offerType === "0",
            );
            // Find all Buy X Discount Y tags (type 4)
            const buyXDiscountYTags = promoTags.filter(
              (tag) => tag.type === 4 && tag.offerType === "1",
            );
            // Find the best matching Buy X Free Y offer for the main item quantity
            let buyXFreeYTag = null;
            if (
              buyXFreeYTags.length > 0 &&
              item.cargo_dist &&
              item.cargo_dist.length > 0
            ) {
              const totalQty = item.cargo_dist.reduce(
                (sum, branch) => sum + Number(branch.quantity || 0),
                0,
              );
              buyXFreeYTag =
                buyXFreeYTags
                  .filter((tag) => Number(tag.order) <= totalQty)
                  .sort((a, b) => Number(b.order) - Number(a.order))[0] ||
                buyXFreeYTags[0];
            }
            // Find the best matching Buy X Discount Y offer for the main item quantity
            let buyXDiscountYTag = null;
            if (
              buyXDiscountYTags.length > 0 &&
              item.cargo_dist &&
              item.cargo_dist.length > 0
            ) {
              const totalQty = item.cargo_dist.reduce(
                (sum, branch) => sum + Number(branch.quantity || 0),
                0,
              );
              buyXDiscountYTag =
                buyXDiscountYTags
                  .filter((tag) => Number(tag.order) <= totalQty)
                  .sort((a, b) => Number(b.order) - Number(a.order))[0] ||
                buyXDiscountYTags[0];
            }
            const itemDiscountTag = promoTags.find((tag) => tag.type === 3);
            const pwpTag = promoTags.find((tag) => tag.type === 5);
            const displayDiscountTag = promoTags.find((tag) => tag.type === 6);

            // Main item branches
            if (item.cargo_dist && item.cargo_dist.length > 0) {
              item.cargo_dist.forEach((branch) => {
                let promoType = "No Promotion";
                let promoIcon = null;

                if (buyXFreeYTag) {
                  promoType = buyXFreeYTag.label;
                  promoIcon = buyXFreeYTag.icon;
                } else if (buyXDiscountYTag) {
                  promoType = buyXDiscountYTag.label;
                  promoIcon = buyXDiscountYTag.icon;
                } else if (itemDiscountTag) {
                  promoType = itemDiscountTag.label;
                  promoIcon = itemDiscountTag.icon;
                } else if (pwpTag) {
                  promoType = pwpTag.label;
                  promoIcon = pwpTag.icon;
                } else if (displayDiscountTag) {
                  promoType = displayDiscountTag.label;
                  promoIcon = displayDiscountTag.icon;
                }

                branchesToRender.push({
                  branch_id: branch.branch_id ?? 0,
                  branch_code: branch.branch_code,
                  quantity: branch.quantity,
                  itemName: item.item_name,
                  itemCode: item.item_code,
                  itemPrice: item.price,
                  promoType,
                  promoIcon,
                  isFree: false,
                  isChild: false,
                });
              });
            }

            // Children branches (always free gift)
            (item.children || []).forEach((child) => {
              let childTag;
              if (child.promotion_type === "4" && child.quantity_offer_id) {
                childTag = promoTags.find(
                  (tag) =>
                    tag.id ===
                    `${child.promotion_id}_${child.quantity_offer_id}`,
                );
              } else if (child.promotion_type === "5") {
                childTag = promoTags.find((tag) => tag.type === 5);
              } else if (child.promotion_type === "6") {
                childTag = promoTags.find((tag) => tag.type === 6);
              } else if (child.promotion_type === "2") {
                childTag = promoTags.find((tag) => tag.type === 2);
              } else {
                childTag = promoTags.find(
                  (tag) => tag.id === child.promotion_id,
                );
              }

              (child.cargo_dist || []).forEach((branch) => {
                branchesToRender.push({
                  branch_id: branch.branch_id ?? 0,
                  branch_code: branch.branch_code,
                  quantity: branch.quantity,
                  itemName: child.item_name,
                  itemCode: child.item_code,
                  itemPrice: child.price,
                  promoType: childTag ? childTag.label : "Promotion",
                  promoIcon: childTag ? childTag.icon : null,
                  isFree: child.promotion_type === "2",
                  isChild: true,
                });
              });
            });

            // Return the item with precomputed branch data
            return {
              ...item,
              branchData: [...branchesToRender].sort(
                (a, b) => Number(a.branch_id) - Number(b.branch_id),
              ),
              promotionTypes,
              offerTypes,
            };
          });

          setCartData({
            ...response.data.results,
            cart: processedWithBranchData,
          });
        } else {
          setCartData(response.data?.results || null);
        }

        // Set pagination info from the API's response
        setTotalItems(response.data?.results?.total_item || 0);

        if (response.data?.pagination) {
          setTotalPages(response.data.pagination.total_pages || 1);
          setCurrentPage(response.data.pagination.current_page || 1);
        } else {
          setTotalPages(1);
        }
      } else {
        setError(response.message || "Failed to fetch cart data");
      }
    } catch (err) {
      console.error("Error loading cart:", err);
      setError("Error loading cart data");
    } finally {
      setLoading(false);
      setIsFirstLoad(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentPage]);

  // Check if PWP requirement is met
  const checkPWPRequirement = () => {
    // 找出所有选中的主商品
    const selectedCartItems =
      cartData?.cart?.filter((item) => selectedItems.includes(item.id)) || [];

    for (const item of selectedCartItems) {
      // 检查主商品是否有 PWP 促销
      const promoTags = getPromotionTags(item.promo_detail || []);
      const hasPWP = promoTags.some((tag) => tag.type === 5);

      if (hasPWP) {
        // 检查该主商品的 children 是否有 PWP 子商品
        const pwpChildren = (item.children || []).filter(
          (child) => child.promotion_type === "5",
        );

        if (pwpChildren.length > 0) {
          // Check if ANY PWP child has quantity > 0 (top-level or in cargo_dist)
          const hasValidPwpChild = pwpChildren.some((child) => {
            const topQty = Number(child.quantity) > 0;
            const branchQty =
              Array.isArray(child.cargo_dist) &&
              child.cargo_dist.some((branch) => Number(branch.quantity) > 0);
            return topQty || branchQty;
          });

          // 如果有 PWP 子商品但没有被选中，则返回 false
          if (!hasValidPwpChild) {
            return false;
          }
        }
        // 如果没有 PWP 子商品，说明还没有添加 PWP 商品，也返回 false
        else {
          return false;
        }
      }
    }
    return true;
  };

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    setCartData(null); // Clear cart data before loading new page
    fetchCartData(page, activeTab, searchTerm);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentPage]);

  const handleTabChange = (pricingType) => {
    setActiveTab(pricingType);
    setSelectedItems([]);
    setSelectedCsIds([]);
    setSelectAll(false);
    setAllMainCartItems([]);
    setSelectedCsItemIds(new Set());
    fetchCounts();
  };

  // Handle search
  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1); // Reset to first page when searching
    fetchCartData("", activeTab, searchTerm);
  };

  // Handle remove item from cart
  const handleRemoveItem = async (items) => {
    try {
      setRemoveLoading(true);
      const itemsArray = Array.isArray(items) ? items : [items];
      const ids = itemsArray.map((i) => i.id).join(",");

      // Call the API to remove the item
      const response = await ApiService.removeFromCart(ids);

      if (response.status === 200) {
        // Refresh cart data after successful deletion
        // await fetchCartData(currentPage, activeTab, searchTerm);
        // Refresh cart totals after successful deletion
        // if (typeof fetchCounts === "function") fetchCounts();
        window.location.reload();
      } else {
        setError(response.message || "Failed to remove item");
      }
    } catch (err) {
      console.error("Error removing cart item:", err);
      setError("Error removing item from cart");
    } finally {
      setRemoveLoading(false);
    }
  };

  function buildStatusMap(data) {
    const map = {};
    (data || []).forEach((item) => {
      const isBundle = String(item.is_bundle) === "1";
      const keyId = String(item.item_id);
      map[`${keyId}_${isBundle ? "1" : "0"}`] = item.id;
    });
    return map;
  }

  // Wishlist functionality
  useEffect(() => {
    ApiService.checkWishlistStatus().then((res) => {
      if (res.status === 200 && Array.isArray(res.data)) {
        setWishlistStatus(buildStatusMap(res.data));
      }
    });
  }, []);

  const addToWishlist = async (item) => {
    // Derive product_type from item properties
    const product_type =
      item.is_package == 1
        ? "package"
        : item.is_bundle == 1
          ? "bundle"
          : "unknown";

    // prevent wishlist for package items
    if (product_type === "package") {
      setNotice({
        show: true,
        message: "Package items cannot be added to wishlist.",
      });
      return;
    }

    // derive keyItemId: use representative/package id for bundles if present
    const keyItemId = item.is_bundle
      ? String(item.representative_item?.id ?? item.package_id ?? item.item_id)
      : String(item.item_id);
    const key = `${keyItemId}_${item.is_bundle ? "1" : "0"}`;
    const wishlistId = wishlistStatus[key];

    try {
      if (wishlistId) {
        const res = await ApiService.removeFromWishlist({
          wishlist_id: wishlistId,
          pricing_type: product_type,
        });
        if (res.status === 200) {
          setWishlistStatus((prev) => {
            const n = { ...prev };
            delete n[key];
            return n;
          });
        }
      } else {
        const bundleId = item.is_bundle ? item.package_id : "0";
        const res = await ApiService.addToWishlist({
          item_id: item.item_id,
          bundle_id: bundleId,
          pricing_type: product_type,
        });
        if (res.status === 200) {
          const checkRes = await ApiService.checkWishlistStatus();
          if (checkRes.status === 200 && Array.isArray(checkRes.data)) {
            setWishlistStatus(buildStatusMap(checkRes.data));
          }
        } else if (res.message === "Wishlist cannot exceed 20 items.") {
          setNotice({ show: true, message: res.message });
        }
      }
    } catch (err) {
      console.error("Wishlist toggle error:", err);
      setNotice({ show: true, message: "Failed to add to wishlist" });
    }
  };

  // Handle edit item - simplified to just navigate to product detail
  const handleEdit = (item) => {
    if (item.is_package === 1 && Number(item.package_type) === 1) {
      navigate(`/myshoppingcart/grouppackagedetail/${item.package_id}`);
    } else if (item.is_package === 1 && Number(item.package_type) !== 1) {
      navigate(`/myshoppingcart/packageproductdetail/${item.package_id}`);
    } else if (item.is_bundle) {
      navigate(
        `/myshoppingcart/productdetail/${item.item_id}?isBundle=1&bundleId=${item.bundle_id}`,
      );
    } else {
      navigate(`/myshoppingcart/productdetail/${item.item_id}`);
    }
  };

  // Format currency
  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Either main item or children is not_available
  function isNotAvailable(item) {
    return (
      item.not_available === true ||
      (Array.isArray(item.children) &&
        item.children.some((child) => child.not_available === true))
    );
  }

  // Sort items so out of stock appears at the bottom
  const sortCartItems = (items) => {
    if (!items) return [];

    // Create a new array with in-stock items first, then out-of-stock items
    const sortedItems = [];
    const outOfStockItems = [];

    items.forEach((item) => {
      if (isNotAvailable(item)) {
        outOfStockItems.push(item);
      } else {
        sortedItems.push(item);
      }
    });

    // Combine the arrays with in-stock items first
    return [...sortedItems, ...outOfStockItems];
  };

  // Handle individual item selection
  const handleSelectItem = (item, isAvailable) => {
    if (!isAvailable) return;

    // If support item, select ALL items sharing the same cs_id together
    const itemIds =
      item.cs_id && item.cs_id !== ""
        ? (cartData?.cart || [])
            .filter((i) => i.cs_id === item.cs_id)
            .map((i) => String(i.id))
        : (item.related_cart_ids || [item.id]).map(String);

    const allSelected = itemIds.every((id) => selectedItems.includes(id));

    if (item.cs_id && item.cs_id !== "") {
      setSelectedCsItemIds((prev) => {
        const next = new Set(prev);
        if (allSelected) {
          itemIds.forEach((id) => next.delete(id));
        } else {
          itemIds.forEach((id) => next.add(id));
        }
        return next;
      });
    }

    if (allSelected) {
      setSelectedItems((prev) => prev.filter((id) => !itemIds.includes(id)));
      setSelectedCsIds((prev) => prev.filter((csId) => csId !== item.cs_id));
    } else {
      setSelectedItems((prev) => {
        const newSelected = [...prev];
        itemIds.forEach((id) => {
          if (!newSelected.includes(id)) newSelected.push(id);
        });
        return newSelected;
      });
      if (item.cs_id) {
        setSelectedCsIds((prev) =>
          prev.includes(item.cs_id) ? prev : [...prev, item.cs_id],
        );
      }
    }
  };

  // useEffect(() => {
  //   console.log("selected item:", selectedItems);
  // }, [selectedItems]);

  const handleSelectAll = async () => {
    if (selectAll) {
      setSelectedItems([]);
      setSelectedCsIds([]);
      setSelectAll(false);
      setAllMainCartItems([]);
      setSelectedCsItemIds(new Set());
    } else {
      try {
        const res = await ApiService.calculateSelectedCartItems(
          "all",
          activeTab,
        );
        const allItemIds = (res.data?.selected_ids || []).map(String);

        // Derive CS item IDs and cs_ids from the "support_" prefix
        const csItemIds = new Set(
          allItemIds.filter((id) => id.startsWith("support_")),
        );
        const allCsIds = [
          ...new Set(
            allItemIds
              .filter((id) => id.startsWith("support_"))
              .map((id) => id.split("_")[1]) // "support_32_2105" → ["support", "32", "2105"] → "32"
              .filter(Boolean),
          ),
        ];

        skipCalculation.current = true;
        skipSelectAllCheck.current = true;
        setSelectedItems(allItemIds);
        setSelectedCsIds(allCsIds.filter(Boolean));
        setAllMainCartItems(cartData?.cart || []);
        setSelectedTotals(res.data);
        setSelectAll(true);
        setSelectedCsItemIds(csItemIds);
      } catch (err) {
        setSelectedItems([]);
        setAllMainCartItems([]);
        setSelectAll(false);
      }
    }
  };

  // Calculate the count of available (in-stock) items
  // const getAvailableItemCount = () => {
  //   if (!cartData?.cart) return 0;
  //   return (cartData?.cart || []).filter(
  //     (item) =>
  //       !item.not_available && !(item.is_foc === 1 || item.price === "0.00"),
  //   ).length;
  // };

  useEffect(() => {
    // Skip if handleSelectAll just ran
    if (cartData?.cart) {
      if (skipSelectAllCheck.current) {
        skipSelectAllCheck.current = false;
        return;
      }

      // Get unique available item IDs (排除 out of stock 和 free gift)
      const availableItemIds = new Set();
      (cartData?.cart || []).forEach((item) => {
        const isAvailable =
          item.is_support_item || !(item.is_foc === 1 || item.price === "0.00");

        if (!item.not_available && isAvailable) {
          availableItemIds.add(String(item.id));
        }
      });

      // Check if all available items are selected
      const allAvailableSelected =
        availableItemIds.size > 0 &&
        Array.from(availableItemIds).every((id) => selectedItems.includes(id));

      setSelectAll(allAvailableSelected);
    }
  }, [selectedItems, cartData]);

  useEffect(() => {
    const calculateSelected = async () => {
      if (skipCalculation.current) {
        skipCalculation.current = false; // reset flag
        return;
      }

      if (selectedItems.length === 0) {
        setSelectedTotals({
          total_item: 0,
          subtotal: 0,
          discount: 0,
          total_shipping_cost: 0,
          total: 0,
        });
        return;
      }

      try {
        const response = await ApiService.calculateSelectedCartItems(
          selectedItems.join(","),
          activeTab,
          selectedCsIds.join(","),
        );

        if (response.status === 200) {
          setSelectedTotals(response.data);
        }
      } catch (err) {
        console.error("Failed to calculate selected items:", err);
      }
    };

    calculateSelected();
  }, [selectedItems, activeTab]);

  const getUniqueItemsWithBranches = (items) => {
    if (!items || !Array.isArray(items)) return [];

    const uniqueItems = {};

    // Group by item_id instead of id_item_id
    items.forEach((item) => {
      const key = `${item.item_id}`;

      if (!uniqueItems[key]) {
        uniqueItems[key] = {
          ...item,
          cargo_dist: [],
        };
      }

      // Add branch information if not already present
      if (item.cargo_dist && item.cargo_dist.length > 0) {
        item.cargo_dist.forEach((branch) => {
          const existingBranchIndex = uniqueItems[key].cargo_dist.findIndex(
            (b) => b.branch_code === branch.branch_code,
          );

          if (existingBranchIndex === -1) {
            uniqueItems[key].cargo_dist.push({ ...branch });
          }
        });
      }
    });

    return Object.values(uniqueItems);
  };

  // PWP addon rows store promotion_id (real promo FK) + pwp_promotion_id
  // (pwp_info sub id) split, like quantity_offer_id — rebuild the composite
  // "{promotion_id}_{sub_id}" tag id from them. Rows that already carry the
  // full composite in pwp_promotion_id (the main item row, or legacy data
  // inserted before the split) are returned as-is.
  function resolvePwpCompositeId(row) {
    if (!row) return null;
    const sub = row.pwp_promotion_id;
    // "0" is the backend's "no PWP sub id" marker on the main item row
    // (PHP's empty("0") is true) but "0" is a truthy string in JS — treat
    // it the same as missing/absent.
    if (!sub || sub === "0") return null;
    return String(sub).includes("_") ? sub : `${row.promotion_id}_${sub}`;
  }

  function getPromotionTags(promoDetail = []) {
    const tags = [];
    const seen = new Set();

    promoDetail.forEach((promo) => {
      const type = parseInt(promo.promotion_type);
      const promoName = promo.promo_name;

      // Free Gift (only free gift use promoName instead of type since the type sometimes wont be returning 2)
      if (promoName === "Free Gift" && promo.free_gift_id) {
        const tagId = `2_${promo.free_gift_id}`;
        if (!seen.has(tagId)) {
          tags.push({
            id: promo.free_gift_id,
            label: "Free Gift",
            type: 2,
            icon: <Gift size={14} />,
          });
          seen.add(tagId);
        }
      }

      // Item Discount
      if (type === 3 && promo.promotion_id) {
        const tagId = `3_${promo.promotion_id}`;
        if (!seen.has(tagId)) {
          tags.push({
            id: promo.promotion_id,
            label: "Item Discount",
            type: 3,
            icon: <Tag size={14} />,
          });
          seen.add(tagId);
        }
      }

      // Quantity Offer (Buy X Free Y or Buy X Discount Y)
      if (type === 4 && promo.quantity_offer_id) {
        const discountValue = parseFloat(promo.discount);
        const tagId = `4_${promo.promotion_id}_${promo.quantity_offer_id}`;
        if (!seen.has(tagId)) {
          if (discountValue > 0) {
            // Format promo_name: "Buy 4 Get 2.0000% Discount" -> "Buy 4 Discount 2%"
            let formattedPromoName = promo.promo_name.replace(
              /Buy (\d+) Get ([\d.]+)% Discount/,
              (match, buyQty, discount) =>
                `Buy ${buyQty} Discount ${parseFloat(discount)}%`,
            );

            tags.push({
              id: `${promo.promotion_id}_${promo.quantity_offer_id}`,
              label: formattedPromoName,
              type: 4,
              offerType: "1",
              offerDiscount: promo.discount,
              icon: <Tag size={14} />,
            });
          } else {
            // Find the free quantity from children
            let freeQty = 0;
            if (Array.isArray(promo.children)) {
              const focChild = promo.children.find(
                (child) =>
                  child.is_foc === 1 &&
                  child.quantity_offer_id === promo.quantity_offer_id,
              );
              if (focChild) {
                freeQty = Number(focChild.quantity);
              }
            }
            if (freeQty > 0) {
              tags.push({
                id: `${promo.promotion_id}_${promo.quantity_offer_id}`,
                label: `${promo.promo_name}`,
                type: 4,
                offerType: "0",
                icon: <Tag size={14} />,
              });
            }
          }
          seen.add(tagId);
        }
      }

      // PWP — prefer pwp_promotion_id: it's set independently of
      // promotion_id now, so it works both for the main item (which may
      // carry its own Discount/Quantity Offer promo_id at the same time)
      // and for the PWP addon child row. The addon row stores promotion_id
      // (real promo FK) and pwp_promotion_id (pwp_info sub id) split, like
      // quantity_offer_id — rebuild the composite "{promotion_id}_{sub_id}"
      // to match the tag id. The main row's pwp_promotion_id is already the
      // full composite, so leave it as-is.
      // Falls back to promotion_id for rows inserted before that column
      // existed (legacy data, promotion_type is still 5 there).
      const pwpId = resolvePwpCompositeId(promo);
      if (pwpId) {
        const tagId = `5_${pwpId}`;
        if (!seen.has(tagId)) {
          tags.push({
            id: pwpId,
            label: "PWP",
            type: 5,
            icon: <Tag size={14} />,
          });
          seen.add(tagId);
        }
      }

      // Display Discount
      if (type === 6 && promo.promotion_id) {
        const tagId = `6_${promo.promotion_id}`;
        if (!seen.has(tagId)) {
          tags.push({
            id: promo.promotion_id,
            label: "Display Discount",
            type: 6,
            icon: <Tag size={14} />,
          });
          seen.add(tagId);
        }
      }
    });
    return tags;
  }

  const handlePromotionTagClick = (
    id,
    tags,
    selectedPromotionIds,
    setSelectedPromotionIds,
  ) => {
    const clickedTag = tags.find((tag) => tag.id === id);
    if (!clickedTag) return;

    if (selectedPromotionIds.includes(id)) {
      // 取消选择
      setSelectedPromotionIds(selectedPromotionIds.filter((pid) => pid !== id));
    } else {
      // 选择
      setSelectedPromotionIds([...selectedPromotionIds, id]);
    }
  };

  function mergeFreeGiftBranches(branches) {
    const merged = {};
    branches.forEach((branch) => {
      // console.log("Merging branch:", branch);
      const key = `${branch.branch_code || "HQ"}-${branch.itemName}`;

      if (branch.promoTag === "Free Gift") {
        // Free Gift 类型：合并同一分支的数量
        if (!merged[key]) {
          merged[key] = { ...branch, quantity: Number(branch.quantity) };
        } else {
          merged[key].quantity += Number(branch.quantity);
        }
      } else {
        // 其他类型：保持独立，使用唯一 key 避免合并
        const uniqueKey = `${key}-${branch.itemId}-${branch.promoTag}`;
        merged[uniqueKey] = { ...branch, quantity: Number(branch.quantity) };
      }
    });
    return Object.values(merged);
  }

  function mergeFreeGiftCards(children) {
    const merged = {};
    children.forEach((child) => {
      if (child.promotion_type === "2") {
        // 只合并 Free Gift 类型
        // 累加所有 branch 的数量
        let totalQty = 0;
        if (Array.isArray(child.cargo_dist)) {
          totalQty = child.cargo_dist.reduce(
            (sum, branch) => sum + Number(branch.quantity || 0),
            0,
          );
        }
        const key = child.item_name;
        if (!merged[key]) {
          merged[key] = { ...child, quantity: totalQty };
        } else {
          merged[key].quantity += totalQty;
        }
      }
    });
    return Object.values(merged);
  }

  function mergeChildrenByItemCode(children) {
    const merged = {};
    children.forEach((child) => {
      const totalQty = Array.isArray(child.cargo_dist)
        ? child.cargo_dist.reduce((sum, b) => sum + Number(b.quantity || 0), 0)
        : 0;
      const key = child.item_code || child.item_name;
      if (!merged[key]) {
        merged[key] = { ...child, quantity: totalQty };
      } else {
        merged[key].quantity += totalQty;
      }
    });
    return Object.values(merged);
  }

  // CartItem component to handle its own state properly
  const CartItem = ({
    item,
    selectedItems,
    handleSelectItem,
    handleEdit,
    addToWishlist,
    formatCurrency,
    activeBranchItemId,
    setActiveBranchItemId,
    activePromoItemId,
    setActivePromoItemId,
  }) => {
    const showCurrPromoMenu = activePromoItemId === item.id;
    const showCartBranch = activeBranchItemId === item.id;

    // 1. Show the promotion tags for each cart item
    const appliedPromoIds = (item.promotion_id || "")
      .split(",")
      .map((id) => id.trim());
    // const allTags = getPromotionTags(item.promo_detail || []);
    const allTags = getPromotionTags([item, ...(item.children || [])]);

    const tags = allTags.filter((tag) => {
      if (tag.type === 4) {
        // Quantity offer: match both promotion_id and quantity_offer_id
        return (
          item.promotion_id &&
          item.quantity_offer_id &&
          tag.id === `${item.promotion_id}_${item.quantity_offer_id}`
        );
      } else if (tag.type === 2) {
        // Free Gift: match free_gift_id
        return item.free_gift_id && tag.id === item.free_gift_id;
      } else if (tag.type === 5) {
        // PWP: allTags is already scoped to just this item + its children
        // (see getPromotionTags call above), so any type-5 tag in it was
        // necessarily built from one of this item's own addon rows.
        return true;
      } else {
        // Other promo: match by promotion_id only
        return item.promotion_id && tag.id === item.promotion_id;
      }
    });

    // 2. Allow user to view and select which promotion
    const [selectedPromotionId, setSelectedPromotionId] = useState(
      tags.length > 0 ? tags[0].id : "",
    );
    const defaultSelected = tags
      .filter((tag) => tag.type === 2)
      .map((tag) => tag.id);
    const [selectedPromotionIds, setSelectedPromotionIds] =
      useState(defaultSelected);
    const [showPromotionDropdown, setShowPromotionDropdown] = useState(false);

    const handlePromotionTagClick = (id) => {
      setSelectedPromotionId(id);
      setShowPromotionDropdown(false);
    };

    // 3. Filter and display promotion_id relevant to the cart item
    // (PWP children carry the link in pwp_promotion_id instead — new rows
    // split it as promotion_id + pwp_promotion_id sub id, so rebuild the
    // composite id; older rows already stored the full composite there)
    const filteredChildren = (item.children || []).filter((child) => {
      if (child.promotion_id === selectedPromotionId) return true;
      const childPwpId = resolvePwpCompositeId(child);
      return childPwpId && childPwpId === selectedPromotionId;
    });

    // 4. Filter and display cargo_dist relevant to the cart item
    const filteredBranches = [];
    filteredChildren.forEach((child) => {
      if (child.cargo_dist && Array.isArray(child.cargo_dist)) {
        child.cargo_dist.forEach((branch) => {
          filteredBranches.push({
            ...branch,
            childName: child.item_name,
            childPrice: child.price,
            childId: child.id,
          });
        });
      }
    });
    const mergedChildren = mergeFreeGiftCards(filteredChildren);

    // Collect all branches from main item and children, with promotion info
    const allBranches = [];

    // Collect promotional branches from children
    (item.children || []).forEach((child) => {
      // const tag = getPromotionTags(item.promo_detail || []).find(
      //   (t) => t.id === child.promotion_id
      // );
      const childPwpId = resolvePwpCompositeId(child);
      const tag = getPromotionTags([item, ...(item.children || [])]).find(
        (t) =>
          t.id === child.promotion_id ||
          (child.pwp_promotion_id && t.id === childPwpId),
      );

      (child.cargo_dist || []).forEach((branch) => {
        allBranches.push({
          branch_code: branch.branch_code,
          quantity: branch.quantity,
          itemName: child.item_name,
          itemPrice: child.price,
          promoType: tag ? tag.label : "Promotion",
          promoIcon: tag ? tag.icon : null,
        });
      });
    });

    // Optionally, only add main item branches that are not covered by promotions
    (item.cargo_dist || []).forEach((branch) => {
      const isPromoted = allBranches.some(
        (b) => b.branch_code === branch.branch_code,
      );
      if (!isPromoted) {
        allBranches.push({
          branch_code: branch.branch_code,
          quantity: branch.quantity,
          itemName: item.item_name,
          itemPrice: item.price,
          promoType: "No Promotion",
          promoIcon: null,
        });
      }
    });

    const displayBranches = mergeFreeGiftBranches(allBranches);
    const uniqueBranchCount = new Set(
      displayBranches.map((b) => b.branch_code || "HQ"),
    ).size;
    // Check if all original IDs for this item are selected
    // For package items, also check that all sibling package items are selected
    const allSelected = (() => {
      const itemIds = (item.related_cart_ids || [item.id]).map(String);
      return (
        itemIds.length > 0 && itemIds.every((id) => selectedItems.includes(id))
      );
    })();

    return (
      <div
        className={`cartitem-container_v2${allSelected ? " active" : ""} ${
          isNotAvailable(item) ? "out-of-stock-item_v2" : ""
        }`}
        id={`cartitem-${item.item_id}-${item.id}`}
      >
        {(item.is_package === 1 ||
          item.quotation_id ||
          item.is_support_item) && (
          <div className="badge-container_v2">
            {item.is_package === 1 && (
              <div className="package-badge_v2">
                PACKAGE : {item.package_name}
              </div>
            )}
            {item.quotation_id && (
              <div className="package-badge_v2">
                QUOTATION : {item.quotation_id}
              </div>
            )}
            {item.is_support_item && (
              <div className="package-badge_v2">SPONSOR</div>
            )}
          </div>
        )}
        {/* Main item information */}
        <div className="cartitem-inner_v2">
          <div className="cartitem-checkbox_v2">
            {(item.is_support_item ||
              !(item.is_foc === 1 || item.price === "0.00")) && (
              <input
                type="checkbox"
                checked={allSelected}
                onChange={() => handleSelectItem(item, !isNotAvailable(item))}
                disabled={isNotAvailable(item)}
              />
            )}
          </div>

          <div className="cart-image-container_v2">
            {isNotAvailable(item) && (
              <div className="out-of-stock-overlay_v2">Not available</div>
            )}
            <FallbackImg
              src={item.img.thumb}
              alt={item.item_name}
              className="cartitem-image_v2"
            />
          </div>

          <div className="cartitem-details_v2">
            <div className="cartitem-top-row_v2">
              <div style={{ width: "80%" }}>
                <div className="cartitem-code_v2">{item.item_code}</div>
                <div className="cartitem-name_v2">{item.item_name}</div>
              </div>

              <div className="cartitem-actions_v2">
                {!(item.is_foc === 1 || item.price === "0.00") && (
                  <>
                    {!isNotAvailable(item) && !item.quotation_id && (
                      <button
                        className="edit-icon_v2"
                        onClick={() => {
                          if (!canCheckout) return;
                          handleEdit(item);
                        }}
                        style={{
                          opacity: canCheckout ? 1 : 0.5,
                          cursor: canCheckout ? "pointer" : "not-allowed",
                        }}
                        title={canCheckout ? "" : "No permission"}
                      >
                        <Pencil size={16} />
                      </button>
                    )}
                    <button
                      className="delete-icon_v2"
                      onClick={() => {
                        if (!canCheckout) return;
                        let relatedItems;
                        if (item.is_package === 1 && item.package_id) {
                          relatedItems = (cartData?.cart || []).filter(
                            (i) =>
                              i.is_package === 1 &&
                              i.package_id === item.package_id,
                          );
                        } else if (item.quotation_id) {
                          relatedItems = (cartData?.cart || []).filter(
                            (i) => i.quotation_id === item.quotation_id,
                          );
                        } else {
                          relatedItems = [item];
                        }
                        setShowDeleteItem(true);
                        setDeleteItem(relatedItems);
                      }}
                      style={{
                        opacity: canCheckout ? 1 : 0.5,
                        cursor: canCheckout ? "pointer" : "not-allowed",
                      }}
                      title={canCheckout ? "" : "No permission"}
                    >
                      <Trash2 size={16} />
                    </button>
                  </>
                )}
              </div>
            </div>

            <div className="cartitem-bot-row_v2">
              <div className="cartitem-price_v2">
                <div className="cartitem-price-title_v2">Unit Price</div>
                {/* {(() => {
                  const selectedTag = tags.find(
                    (tag) => tag.id === selectedPromotionId,
                  );
                  const originalPrice =
                    Number(item.price) + Number(item.discount || 0);

                  // FOCPrice calculation
                  const quantity = item.cargo_dist
                    ? item.cargo_dist.reduce(
                        (sum, branch) => sum + Number(branch.quantity || 0),
                        0,
                      )
                    : 0;

                  const foc = (item.children || [])
                    .filter((child) => String(child.promotion_type) === "4")
                    .reduce((sum, child) => {
                      if (Array.isArray(child.cargo_dist)) {
                        return (
                          sum +
                          child.cargo_dist.reduce(
                            (s, b) => s + Number(b.quantity || 0),
                            0,
                          )
                        );
                      }
                      return sum;
                    }, 0);

                  const FOCPrice =
                    (quantity * originalPrice) / (quantity + foc);

                  // console.log("quantity", quantity);
                  // console.log("foc", foc);

                  // Show discounted price only for Item Discount (type === 3)
                  if (selectedTag && selectedTag.type === 3) {
                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span className="normalprice_v2">
                          RM{" "}
                          {item.brand_price
                            ? formatCurrency(item.brand_price)
                            : "0.00"}
                        </span>
                        <span className="deductedprice_v2">
                          RM{" "}
                          {originalPrice
                            ? formatCurrency(originalPrice)
                            : "0.00"}
                        </span>
                      </div>
                    );
                  }

                  // Show discounted price only for Buy X Discount Y (type === 4)
                  else if (
                    selectedTag &&
                    selectedTag.type === 4 &&
                    selectedTag.offerType === "1"
                  ) {
                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span className="normalprice_v2">
                          RM {item.price ? formatCurrency(item.price) : "0.00"}
                        </span>
                        <span className="deductedprice_v2">
                          RM{" "}
                          {originalPrice
                            ? formatCurrency(originalPrice)
                            : "0.00"}
                        </span>
                      </div>
                    );
                  }

                  // Show discounted price only for Buy X Free Y (type === 4)
                  else if (selectedTag && selectedTag.type === 4) {
                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span className="normalprice_v2">
                          RM {FOCPrice ? formatCurrency(FOCPrice) : "0.00"}
                        </span>
                        <span className="deductedprice_v2">
                          RM{" "}
                          {originalPrice
                            ? formatCurrency(originalPrice)
                            : "0.00"}
                        </span>
                      </div>
                    );
                  }

                  // Otherwise, show CartItemonly the current price
                  return (
                    <span className="normalprice_v2">
                      RM {item.price ? formatCurrency(item.price) : "0.00"}
                    </span>
                  );
                })()} */}
                {(() => {
                  const selectedTag = tags.find(
                    (tag) => tag.id === selectedPromotionId,
                  );

                  return selectedTag &&
                    (selectedTag.type === 3 ||
                      (selectedTag.type === 4 &&
                        selectedTag.offerType === "1")) ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span className="normalprice_v2">
                        RM{" "}
                        {item.final_price
                          ? formatCurrency(item.final_price)
                          : "0.00"}
                      </span>
                      <span className="deductedprice_v2">
                        RM{" "}
                        {item.original_price
                          ? formatCurrency(item.original_price)
                          : "0.00"}
                      </span>
                    </div>
                  ) : (
                    <span className="normalprice_v2">
                      RM {item.price ? formatCurrency(item.price) : "0.00"}
                    </span>
                  );
                })()}
              </div>

              {/* Wishlist button for out of stock items */}
              {isNotAvailable(item) &&
                (() => {
                  const wishlistKey = `${String(item.item_id)}_${item.is_bundle ? "1" : "0"}`;
                  const isInWishlist = !!wishlistStatus[wishlistKey];
                  return (
                    <button
                      className={`add-to-wishlist-button_v2${isInWishlist ? " active" : ""}`}
                      onClick={() => addToWishlist(item)}
                    >
                      {isInWishlist
                        ? "Remove From Wishlist"
                        : "Add To Wishlist"}
                    </button>
                  );
                })()}

              {!isNotAvailable(item) && (
                <>
                  <div className="cartitem-qty_v2">
                    <div className="cartitem-qty-title_v2">Quantity</div>
                    <div className="cartitem-qty-value-container_v2">
                      <div className="cartitem-qty-value_v2">
                        {item.cargo_dist
                          ? item.cargo_dist.reduce(
                              (sum, branch) =>
                                sum + Number(branch.quantity || 0),
                              0,
                            )
                          : 0}
                      </div>
                      {(() => {
                        const focQty = (item.children || [])
                          .filter(
                            (child) => String(child.promotion_type) === "4",
                          )
                          .reduce((sum, child) => {
                            if (Array.isArray(child.cargo_dist)) {
                              return (
                                sum +
                                child.cargo_dist.reduce(
                                  (s, b) => s + Number(b.quantity || 0),
                                  0,
                                )
                              );
                            }
                            return sum;
                          }, 0);

                        return focQty > 0 ? (
                          <div className="cartitem-qty-foc_v2">
                            + {focQty} free
                          </div>
                        ) : null;
                      })()}
                    </div>
                  </div>

                  <div className="cartitem-total_v2">
                    <div className="cartitem-total-title_v2">Subtotal</div>
                    <div className="cartitem-RM-container_v2">
                      <div className="cartitem-RM_v2">RM</div>
                      {formatCurrency(
                        (item.price ? Number(item.price) : 0) *
                          (item.cargo_dist
                            ? item.cargo_dist.reduce(
                                (sum, branch) =>
                                  sum + Number(branch.quantity || 0),
                                0,
                              )
                            : 0),
                      )}
                    </div>
                    {(() => {
                      const focQty = (item.children || [])
                        .filter((child) => String(child.promotion_type) === "4")
                        .reduce((sum, child) => {
                          if (Array.isArray(child.cargo_dist)) {
                            return (
                              sum +
                              child.cargo_dist.reduce(
                                (s, b) => s + Number(b.quantity || 0),
                                0,
                              )
                            );
                          }
                          return sum;
                        }, 0);

                      return focQty > 0 ? (
                        <div className="cartitem-RM-foc_v2">
                          Save RM{" "}
                          {item.price
                            ? formatCurrency(item.price * focQty)
                            : "0.00"}{" "}
                          on {focQty} free {focQty > 1 ? "units" : "unit"}
                        </div>
                      ) : null;
                    })()}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="branch-toggle-container_v2">
          <div
            className="branch-toggle_v2"
            onClick={(e) => {
              e.stopPropagation();
              const next = showCartBranch ? null : item.id;
              setActiveBranchItemId(next);
              if (next !== null) setActivePromoItemId(null);
            }}
          >
            <div className="branch-toggle-left_v2">
              <Package size={16} color={"#1e5bc6"} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                  fontSize: "14px",
                }}
              >
                Stock Allocation
                <div className="branch-toggle-count_v2">
                  {uniqueBranchCount || 0}{" "}
                  {uniqueBranchCount === 1 ? "branch" : "branches"} allocated
                </div>
              </div>
            </div>
            <ChevronDown
              size={16}
              className={showCartBranch ? "rotate_v2" : ""}
            />
          </div>

          {tags.length > 0 && (
            <div
              className="currpromo-dropdown_v2"
              onClick={(e) => {
                e.stopPropagation();
                const next = showCurrPromoMenu ? null : item.id;
                setActivePromoItemId(next);
                if (next !== null) setActiveBranchItemId(null);
              }}
            >
              <div className="currpromo-dropdown-left_v2">
                <Tag size={16} color={"#00a63e"} />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                    fontSize: "14px",
                  }}
                >
                  Applied Promotions
                  <div className="currpromo-dropdown-count_v2">
                    {tags.length || 0}{" "}
                    {tags.length === 1 ? "promotion" : "promotions"} applied
                  </div>
                </div>
              </div>
              <ChevronDown
                size={16}
                className={showCurrPromoMenu ? "rotate_v2" : ""}
              />
            </div>
          )}
        </div>

        {/* CSS in ShoppingCartBranch.css */}
        {showCartBranch && (
          <BranchDistributionModal
            branches={item.branchData || []}
            promotionTypes={item.promotionTypes || []}
            offerTypes={item.offerTypes || []}
            isPackage={item.is_package || ""}
            id={item.id || ""}
            itemId={item.item_id || ""}
            customerId={item.customer_id || ""}
            quotationId={item.quotation_id || ""}
            itemQty={
              item.cargo_dist
                ? item.cargo_dist.reduce(
                    (sum, branch) => sum + Number(branch.quantity || 0),
                    0,
                  )
                : 0
            }
            package_seperate={item.package_seperate || ""}
            packing_quantity={item.packing_quantity || ""}
            isSupportItem={item.is_support_item || false}
            cs_id={item.cs_id || ""}
            bundleId={item.bundle_id || item.bundleId || ""}
            branchRegion={item.branch_region || ""}
          />
        )}

        {/* Show All Promotion */}
        {showCurrPromoMenu && tags.length > 0 && (
          <div className="currpromo-menu_v2">
            <div className="currpromo-title_v2">Applied Promotions</div>
            {tags.map((tag) => {
              // For each tag, find the children and render the promo card.
              // PWP children carry the link in pwp_promotion_id (their own
              // promotion_id is "0"), so match on that for PWP tags.
              const promoChildren = (item.children || []).filter((child) =>
                tag.type === 5
                  ? resolvePwpCompositeId(child) === tag.id
                  : child.promotion_id === tag.id,
              );

              const mergedPromoChildren =
                mergeChildrenByItemCode(promoChildren);

              // Item Discount (type 3)
              if (tag.type === 3) {
                const originalPrice =
                  Number(item.price) + Number(item.discount || 0);
                return (
                  <div
                    className="currpromo-branch_v2"
                    key={item.item_id + "-" + tag.id}
                  >
                    <div className="currpromo-left_v2">
                      <FallbackImg src={item.img?.thumb} alt={item.item_name} />
                    </div>
                    <div className="currpromo-center_v2">
                      <div className="promoitem-name_v2">{item.item_code}</div>
                      <div className="promoitem-qty_v2">
                        Quantity :{" "}
                        {item.cargo_dist.reduce(
                          (sum, b) => sum + Number(b.quantity || 0),
                          0,
                        )}
                      </div>
                      <div className="promoitem-price_v2">
                        <span>
                          RM{" "}
                          {item.brand_price
                            ? formatCurrency(item.brand_price)
                            : "0.00"}
                        </span>
                        <span
                          style={{
                            textDecoration: "line-through",
                            color: "#a1a1a1",
                            marginLeft: 8,
                            fontSize: "12px",
                          }}
                        >
                          RM{" "}
                          {originalPrice
                            ? formatCurrency(originalPrice)
                            : "0.00"}
                        </span>
                      </div>
                    </div>
                    <div className="currpromo-right_v2">
                      <div className="promoitem-tag_v2 orange">
                        {tag.icon}
                        {tag.label}
                      </div>
                    </div>
                  </div>
                );
              }

              // Free Gift (type 2)
              if (tag.type === 2 && promoChildren.length > 0) {
                const totalQty = promoChildren.reduce((sum, child) => {
                  if (Array.isArray(child.cargo_dist)) {
                    return (
                      sum +
                      child.cargo_dist.reduce(
                        (s, b) => s + Number(b.quantity || 0),
                        0,
                      )
                    );
                  }
                  return sum;
                }, 0);
                const child = promoChildren[0];
                return (
                  <div
                    className="currpromo-branch_v2"
                    key={child.item_name + "-" + tag.id}
                  >
                    <div className="currpromo-left_v2">
                      <FallbackImg
                        src={child.img?.thumb}
                        alt={child.item_name}
                      />
                    </div>
                    <div className="currpromo-center_v2">
                      <div className="promoitem-name_v2">{child.item_code}</div>
                      <div className="promoitem-qty_v2">
                        Quantity : {totalQty}
                      </div>
                      <div className="promoitem-price_v2">
                        <span>RM 0.00</span>
                      </div>
                    </div>
                    <div className="currpromo-right_v2">
                      <div className="promoitem-tag_v2 green">
                        {tag.icon}
                        {tag.label}
                      </div>
                    </div>
                  </div>
                );
              }

              // Quantity Offer - Buy X Discount Y (type 4, offerType 1)
              if (tag.type === 4 && tag.offerType === "1") {
                const originalPrice =
                  Number(item.price) + Number(item.discount || 0);
                return (
                  <div
                    className="currpromo-branch_v2"
                    key={item.item_id + "-" + tag.id}
                  >
                    <div className="currpromo-left_v2">
                      <FallbackImg src={item.img?.thumb} alt={item.item_name} />
                    </div>
                    <div className="currpromo-center_v2">
                      <div className="promoitem-name_v2">{item.item_code}</div>
                      <div className="promoitem-qty_v2">
                        Quantity :{" "}
                        {item.cargo_dist.reduce(
                          (sum, b) => sum + Number(b.quantity || 0),
                          0,
                        )}
                      </div>
                      <div className="promoitem-price_v2">
                        <span>
                          RM {item.price ? formatCurrency(item.price) : "0.00"}
                        </span>
                        <span
                          style={{
                            textDecoration: "line-through",
                            color: "#a1a1a1",
                            marginLeft: 8,
                            fontSize: "12px",
                          }}
                        >
                          RM{" "}
                          {originalPrice
                            ? formatCurrency(originalPrice)
                            : "0.00"}
                        </span>
                      </div>
                    </div>
                    <div className="currpromo-right_v2">
                      <div className="promoitem-tag_v2 purple">
                        {tag.icon}
                        {tag.label}
                      </div>
                    </div>
                  </div>
                );
              }

              // Quantity Offer - Buy X Free Y (type 4, offerType 0)
              if (tag.type === 4) {
                // Sum all cargo_dist quantities for children with promotion_type === 4
                const totalFocQty = (item.children || [])
                  .filter((child) => String(child.promotion_type) === "4")
                  .reduce((sum, child) => {
                    if (Array.isArray(child.cargo_dist)) {
                      return (
                        sum +
                        child.cargo_dist.reduce(
                          (s, b) => s + Number(b.quantity || 0),
                          0,
                        )
                      );
                    }
                    return sum;
                  }, 0);
                return (
                  <div
                    className="currpromo-branch_v2"
                    key={item.item_id + "-" + tag.id}
                  >
                    <div className="currpromo-left_v2">
                      <FallbackImg src={item.img?.thumb} alt={item.item_name} />
                    </div>
                    <div className="currpromo-center_v2">
                      <div className="promoitem-name_v2">{item.item_code}</div>
                      <div className="promoitem-qty_v2">
                        Quantity : {totalFocQty}
                      </div>
                      <div className="promoitem-price_v2">
                        <span>RM 0.00</span>
                      </div>
                    </div>
                    <div className="currpromo-right_v2">
                      <div className="promoitem-tag_v2 purple">
                        {tag.icon}
                        {tag.label}
                      </div>
                    </div>
                  </div>
                );
              }

              // Other promo types (e.g., PWP, Display Discount, etc.)
              return mergedPromoChildren.map((child) => {
                const totalQty = child.quantity; // already summed by the merge step

                return (
                  <div
                    className="currpromo-branch_v2"
                    key={child.item_code + "-" + tag.id}
                  >
                    <div className="currpromo-left_v2">
                      <FallbackImg
                        src={child.img?.thumb}
                        alt={child.item_name}
                      />
                    </div>
                    <div className="currpromo-center_v2">
                      <div className="promoitem-name_v2">{child.item_code}</div>
                      <div className="promoitem-qty_v2">
                        Quantity : {totalQty}
                      </div>
                      <div className="promoitem-price_v2">
                        {child.promotion_type === "2" ||
                        child.promotion_type === "4" ? (
                          <span>RM 0.00</span>
                        ) : (
                          <>
                            <span>
                              RM{" "}
                              {child.price
                                ? formatCurrency(child.price)
                                : "0.00"}
                            </span>
                            <span
                              style={{
                                textDecoration: "line-through",
                                color: "#a1a1a1",
                                marginLeft: 8,
                                fontSize: "12px",
                              }}
                            >
                              RM{" "}
                              {formatCurrency(
                                Number(child.price) +
                                  Number(child.discount || 0),
                              )}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="currpromo-right_v2">
                      <div className="promoitem-tag_v2 orange">
                        {tag.icon}
                        {tag.label}
                      </div>
                    </div>
                  </div>
                );
              });
            })}
          </div>
        )}
      </div>
    );
  };

  // Prepare selected item IDs for checkout
  const getSelectedCartIds = () => {
    if (selectedTotals?.selected_ids?.length > 0) {
      return selectedTotals.selected_ids
        .filter((id) => !String(id).startsWith("support_"))
        .join(",");
    }

    return selectedItems
      .filter((id) => !String(id).startsWith("support_"))
      .join(",");
  };

  const getSelectedCsIds = () => {
    // Filter out falsy/empty values so we don't produce a leading/trailing comma
    return (selectedCsIds || []).filter(Boolean).join(",");
  };

  // Handle Order List popup (remark step)
  const openOrderListPopup = async () => {
    setOrderListLoading(true);
    try {
      const response = await ApiService.getMyCart(
        1,
        activeTab,
        999999,
        "",
        selectedItems.join(","),
        selectedCsIds,
      );
      if (response.status === 200) {
        const cartResults = response.data?.results;
        // Extract customer_id from response
        let customerId =
          cartResults?.customer_id ||
          (Array.isArray(cartResults?.cart) && cartResults.cart.length > 0
            ? cartResults.cart[0].customer_id
            : null) ||
          q_customer_id ||
          localStorage.getItem("customer_id") ||
          "";
        setOrderListFetchedCart({
          customerId: String(customerId),
          cart: cartResults?.cart || [],
          pricingType: activeTab,
        });
        if (customerId) setQCustomerId(String(customerId));
      }
    } catch (err) {
      console.error("Failed to fetch cart for order list:", err);
    } finally {
      setOrderListLoading(false);
      setShowOrderListPopup(true);
    }
  };

  const closeOrderListPopup = () => {
    setShowOrderListPopup(false);
  };

  // Submit POST form for Order List into the doc popup iframe
  const submitOrderListForm = (remark, fetchedCart) => {
    try {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = `${BACKEND_URL}pdf_report/order_listing`;
      // Open result in a new tab/window instead of iframe popup
      form.target = "_blank";

      const customerIdInput = document.createElement("input");
      customerIdInput.type = "hidden";
      customerIdInput.name = "q_customer_id";
      customerIdInput.value =
        fetchedCart?.customerId ||
        q_customer_id ||
        localStorage.getItem("customer_id") ||
        "";
      form.appendChild(customerIdInput);

      const pricingTypeInput = document.createElement("input");
      pricingTypeInput.type = "hidden";
      pricingTypeInput.name = "q_pricing_type";
      pricingTypeInput.value = fetchedCart?.pricingType || activeTab || "";
      form.appendChild(pricingTypeInput);

      const availableListInput = document.createElement("input");
      availableListInput.type = "hidden";
      availableListInput.name = "q_available_list";
      availableListInput.value = fetchedCart?.cart
        ? fetchedCart.cart
            .map((item) => item.id)
            .filter(Boolean)
            .join(",")
        : selectedItems.join(",");
      form.appendChild(availableListInput);

      const remarkInput = document.createElement("input");
      remarkInput.type = "hidden";
      remarkInput.name = "q_remark";
      remarkInput.value = remark || "";
      form.appendChild(remarkInput);

      const selectedTotalsInput = document.createElement("input");
      selectedTotalsInput.type = "hidden";
      selectedTotalsInput.name = "selected_totals";
      selectedTotalsInput.value = JSON.stringify(selectedTotals) || "";
      form.appendChild(selectedTotalsInput);

      const cartJsonInput = document.createElement("input");
      cartJsonInput.type = "hidden";
      cartJsonInput.name = "q_cart_json";
      cartJsonInput.value = JSON.stringify(fetchedCart?.cart || []);
      form.appendChild(cartJsonInput);

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    } catch (err) {
      console.error("Failed to submit order list form:", err);
    }
  };

  // Step 1: Remark input popup
  const OrderListPopup = () => {
    const [remark, setRemark] = useState("");
    if (!showOrderListPopup) return null;

    const handleSubmit = () => {
      setShowOrderListPopup(false); // close remark popup
      // Submit form and open PDF in a new tab/window
      submitOrderListForm(remark, orderListFetchedCart);
    };

    return (
      <div className="doc-preview-overlay_v2" onClick={closeOrderListPopup}>
        <div
          className="doc-preview-container_v2"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="doc-preview-title-container_v2">
            <div className="doc-preview-title_v2">
              <strong>Generate Order List</strong>
            </div>
            <button
              className="doc-preview-close-btn_v2"
              onClick={closeOrderListPopup}
              title="Close"
            >
              <X />
            </button>
          </div>

          <div className="doc-preview-main_v2">
            <div className="doc-preview-label_v2">
              You are about to generate an order list for{" "}
              <span>
                {selectedTotals.total_item} selected{" "}
                {selectedTotals.total_item === 1 ? "item" : "items"}
              </span>
              .
            </div>

            <div className="doc-preview-total_v2">
              <div className="doc-preview-total-item_v2">
                <div>Subtotal :</div>
                <div className="doc-preview-total-value_v2">
                  <div className="doc-preview-RM_v2">RM</div>
                  <div>{formatCurrency(selectedTotals.subtotal)}</div>
                </div>
              </div>

              <div className="doc-preview-total-item_v2">
                <div>Discount :</div>
                <div className="doc-preview-total-value_v2">
                  <div className="doc-preview-RM_v2">- RM</div>
                  <div>
                    {selectedTotals.discount
                      ? formatCurrency(selectedTotals.discount)
                      : "0.00"}
                  </div>
                </div>
              </div>

              <div className="doc-preview-total-item_v2 seperator">
                <div>Delivery Changes :</div>

                {selectedTotals.total_shipping_cost === 0 ? (
                  <span style={{ color: "#00a63e" }}>FREE</span>
                ) : (
                  <div className="doc-preview-total-value_v2">
                    <div className="doc-preview-RM_v2">RM</div>
                    <div>
                      {formatCurrency(selectedTotals.total_shipping_cost)}
                    </div>
                  </div>
                )}
              </div>

              <div className="doc-preview-total-item_v2">
                <div>Total:</div>
                <div className="doc-preview-total-value_v2">
                  <div className="doc-preview-RM_v2">RM</div>
                  <div>
                    {selectedTotals.total
                      ? formatCurrency(selectedTotals.total)
                      : "0.00"}
                  </div>
                </div>
              </div>
            </div>

            <div style={{ marginBottom: "8px" }}>
              Remarks <span style={{ color: "#525252" }}>(Optional)</span>
            </div>
            <textarea
              className="doc-preview-input_v2"
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Enter any additional notes or special instructions..."
              rows={5}
            />
          </div>

          <div className="doc-preview-sub_v2">
            <button className="doc-preview-no_v2" onClick={closeOrderListPopup}>
              Cancel
            </button>
            <button className="doc-preview-yes_v2" onClick={handleSubmit}>
              Generate
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Removed iframe document popup — order list now opens in a new tab/window

  const handleEditBranch = ({
    id,
    itemId,
    customerId,
    quotationId,
    itemQty,
    package_seperate,
    packing_quantity,
    csId,
    bundleId,
    branchRegion,
  }) => {
    // Keep the original cart `id` and store `cs_id` separately for support items
    setEditCartItem({
      id: id,
      cs_id: csId ?? null,
      bundleId: bundleId ?? null,
      itemId,
      customerId,
      quotationId,
      itemQty,
      package_seperate,
      packing_quantity,
      branch_region: branchRegion ?? "",
    });
    setShowEditCart(true);
  };

  const BranchDistributionModal = ({
    branches,
    promotionTypes = [],
    offerTypes = [],
    isPackage = false,
    id = "",
    itemId = "",
    customerId = "",
    quotationId = "",
    itemQty = 0,
    package_seperate = "",
    packing_quantity = "",
    isSupportItem = false,
    bundleId = "",
    cs_id = "",
    branchRegion = "",
  }) => {
    const isFOC = promotionTypes.includes(4) && offerTypes.includes("0");
    const isPWP = promotionTypes.includes(5);
    const isDisplayDiscount = promotionTypes.includes(6);
    // If any branch carries a sponsor-related promo tag/type, treat it as sponsor
    const hasSponsorTag = (branches || []).some((b) => {
      const promoType = b.promoType || "";
      const promoTag = b.promoTag || "";
      return (
        String(promoType).toLowerCase().includes("sponsor") ||
        String(promoTag).toLowerCase().includes("sponsor")
      );
    });
    const renderedBranchNames = new Set();

    // Holds { branch_code, items: [{code, qty}] } for the branch whose
    // "View More" was clicked, or null when the modal is closed.
    const [pwpDetailBranch, setPwpDetailBranch] = useState(null);

    return (
      <>
        <div className="shoppingcartbranch_v2">
          <div className="scb-title_v2">
            <div>Branch Distribution</div>
            {!(
              isFOC ||
              isPWP ||
              isDisplayDiscount ||
              isSupportItem ||
              hasSponsorTag
            ) && (
              <div
                className="scb-edit-icon_v2"
                onClick={() =>
                  handleEditBranch({
                    id,
                    itemId,
                    customerId,
                    quotationId,
                    itemQty,
                    package_seperate,
                    packing_quantity,
                    bundleId,
                    branchRegion,
                  })
                }
              >
                <Pencil size={12} />
                Edit
              </div>
            )}
            {isSupportItem && (
              <div
                className="scb-edit-icon_v2"
                onClick={() =>
                  handleEditBranch({
                    id,
                    itemId,
                    customerId,
                    quotationId,
                    itemQty,
                    package_seperate,
                    packing_quantity,
                    csId:
                      cs_id ||
                      (String(id).startsWith("support_")
                        ? String(id).split("_")[1]
                        : id),
                    bundleId: bundleId || "",
                    branchRegion,
                  })
                }
              >
                <Pencil size={12} />
                Edit
              </div>
            )}
          </div>

          <div className="shoppingcartbranch-content_v2">
            <div className="scb-branch-header_v2">
              <div className="scb-subtitle-col1_v2">Branch</div>
              <div className="scb-subtitle-remaincol_v2">Quantity</div>
              {isFOC && <div className="scb-subtitle-remaincol_v2">F.O.C</div>}
              {isPWP && <div className="scb-subtitle-remaincol_v2">PWP</div>}
              {isDisplayDiscount && (
                <div className="scb-subtitle-remaincol_v2">Discount</div>
              )}
            </div>

            {branches && branches.length > 0 ? (
              (() => {
                const anyBranchHasMultiplePwpCodes = branches.some((b) => {
                  const grp = branches.filter(
                    (x) => x.branch_code === b.branch_code,
                  );
                  const codes = [
                    ...new Set(
                      grp
                        .filter((x) => x.isChild && x.promoType === "PWP")
                        .map((x) => x.itemCode),
                    ),
                  ];
                  return codes.length > 1;
                });
                return branches.map((branch, idx) => {
                  // Only render branch name once per branch_code
                  if (renderedBranchNames.has(branch.branch_code)) return null;
                  renderedBranchNames.add(branch.branch_code);

                  // Find all branches for this branch_code
                  const branchGroup = branches.filter(
                    (b) => b.branch_code === branch.branch_code,
                  );

                  // Sum quantities for each type
                  const mainQty = branchGroup
                    .filter(
                      (b) =>
                        !b.isChild &&
                        ((b.promoType &&
                          b.promoType.startsWith("Buy ") &&
                          b.promoType.includes(" Free ")) ||
                          (b.promoType &&
                            b.promoType.startsWith("Buy ") &&
                            b.promoType.includes(" Discount ")) ||
                          b.promoType === "PWP" ||
                          b.promoType === "Display Discount" ||
                          b.promoType === "Item Discount" ||
                          b.promoType === "No Promotion"),
                    )
                    .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

                  const focQty = branchGroup
                    .filter(
                      (b) =>
                        b.isChild &&
                        b.promoType &&
                        b.promoType.startsWith("Buy ") &&
                        b.promoType.includes(" Free "),
                    )
                    .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

                  const pwpQty = branchGroup
                    .filter((b) => b.isChild && b.promoType === "PWP")
                    .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

                  const discountQty = branchGroup
                    .filter(
                      (b) => b.isChild && b.promoType === "Display Discount",
                    )
                    .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

                  const freeGiftQty = branchGroup
                    .filter((b) => b.promoType === "Free Gift")
                    .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

                  // Distinct PWP item codes for THIS branch only, in first-seen order
                  const branchPwpCodes = [];
                  branchGroup
                    .filter((b) => b.isChild && b.promoType === "PWP")
                    .forEach((b) => {
                      if (!branchPwpCodes.includes(b.itemCode)) {
                        branchPwpCodes.push(b.itemCode);
                      }
                    });

                  return (
                    <div key={idx} className="shoppingcartbranch-main_v2">
                      <div className="scb-branchname-container_v2">
                        <div className="scb-branchname_v2">
                          {branch.branch_code || "HQ"}
                        </div>

                        {/* Main quantity */}
                        <div className="scb-productqty-container_v2">
                          <div className="scb-productqty-value_v2">
                            {mainQty}
                          </div>
                        </div>

                        {/* FOC quantity */}
                        {isFOC && (
                          <div className="scb-productqty-container_v2">
                            <div className="scb-productqty-value_v2">
                              {focQty}
                            </div>
                          </div>
                        )}

                        {/* PWP quantity */}
                        {isPWP && (
                          <div
                            className="scb-productqty-container_v2"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {anyBranchHasMultiplePwpCodes && (
                              <button
                                type="button"
                                className="scb-viewmore-btn_v2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setPwpDetailBranch({
                                    branch_code: branch.branch_code || "HQ",
                                    items: branchPwpCodes.map((code) => ({
                                      code,
                                      qty: branchGroup
                                        .filter(
                                          (b) =>
                                            b.isChild &&
                                            b.promoType === "PWP" &&
                                            b.itemCode === code,
                                        )
                                        .reduce(
                                          (sum, b) =>
                                            sum + Number(b.quantity || 0),
                                          0,
                                        ),
                                    })),
                                  });
                                }}
                              >
                                View More
                              </button>
                            )}
                            <div className="scb-productqty-value_v2">
                              {pwpQty}
                            </div>
                          </div>
                        )}

                        {/* Display Discount quantity */}
                        {isDisplayDiscount && (
                          <div className="scb-productqty-container_v2">
                            <div className="scb-productqty-value_v2">
                              {discountQty}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                });
              })()
            ) : (
              <div>No branch info available.</div>
            )}
          </div>
        </div>

        {pwpDetailBranch && (
          <MultiPurpose
            title={`PWP Branch Distribution - ${pwpDetailBranch.branch_code}`}
            hideNo={true}
            yesText="Close"
            onYes={() => setPwpDetailBranch(null)}
            onClose={() => setPwpDetailBranch(null)}
          >
            <div className="shoppingcartbranch-content_v2">
              <div
                className="scb-branch-header_v2"
                style={{ textAlign: "left" }}
              >
                <div className="scb-subtitle-col1_v2">Branch</div>
                {pwpDetailBranch.items.map((it) => (
                  <div key={it.code} className="scb-subtitle-remaincol_v2">
                    {it.code}
                  </div>
                ))}
              </div>

              <div className="shoppingcartbranch-main_v2">
                <div className="scb-branchname-container_v2">
                  <div className="scb-branchname_v2">
                    {pwpDetailBranch.branch_code}
                  </div>
                  {pwpDetailBranch.items.map((it) => (
                    <div key={it.code} className="scb-productqty-container_v2">
                      <div className="scb-productqty-value_v2">{it.qty}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </MultiPurpose>
        )}
      </>
    );
  };

  const handleGetUnsuccessfulAndOverdueTotal = async () => {
    try {
      const res = await ApiService.getUnsuccessfulAndOverdueTotal();

      if (res.status === 200 && res.data) {
        const overdue = Number(res.data.overdue_total_amount) || 0;
        const unsuccessful = Number(res.data.unsuccessful_total_amount) || 0;
        const unpaid = Number(res.data.unpaid_order_amount) || 0;

        return { overdue, unsuccessful, unpaid }; // return the values
      }
    } catch (error) {
      console.error("Failed to fetch totals:", error);
    }
    return null;
  };

  const handleGetCreditLimit = async () => {
    try {
      const res = await ApiService.getCreditLimit();

      if (res.status === 200 && res.data) {
        const credit_limit = Number(res.data.credit_limit) || 0;
        const invoice_used = Number(res.data.invoice_used) || 0;
        const do_used = Number(res.data.do_used) || 0;
        const used_amount = Number(res.data.used_amount) || 0;
        const remaining = Number(res.data.remaining) || 0;

        return remaining; // return the values
      }
    } catch (error) {
      if (error.response.data) {
        return error.response.data.data;
      }
      console.error("Failed to fetch credit limit:", error);
    }
    return null;
  };

  return (
    <div className="myshopcart_v2">
      <Breadcrums />
      <div className="myshopcart-content_v2">
        {canView ? (
          <>
            <div className="myshopcart-title-container_v2">
              <div className="myshopcart-title_v2">
                <strong>MY SHOPPING CART ({cartCount})</strong>
              </div>
            </div>

            <div className="myshopcart-inner_v2">
              <div className="myshopcart-left_v2">
                <div className="myshopcart-main_v2">
                  <div className="myshopcart-tab-container_v2">
                    {pricingTypes.map((type) => {
                      const raw = cartByPricingTypeCount
                        ? cartByPricingTypeCount[type.pricing_type]
                        : undefined;
                      const countValue = Array.isArray(raw)
                        ? raw.length
                        : Number(raw) || 0;

                      return (
                        <div
                          key={type.pricing_type}
                          className={`myshopcart-tab_v2${
                            activeTab === type.pricing_type
                              ? " active-tab_v2"
                              : ""
                          }`}
                          onClick={() => handleTabChange(type.pricing_type)}
                        >
                          <span>{type.pricing_name}</span>
                          <span className="myshopcart-tab-count">
                            {countValue} {countValue === 1 ? "item" : "items"}
                          </span>
                        </div>
                      );
                    })}
                  </div>

                  <div className="myshopcart-list_v2">
                    <div className="msc-selectall-container_v2">
                      {/* Select All checkbox */}
                      <div className="msc-selectall_v2">
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />
                        Select All
                      </div>

                      {/* Searchbar */}
                      <div className="myshopcart-searchbar_v2">
                        <Search
                          color={"#798777"}
                          size={16}
                          style={{ width: "40px" }}
                        />
                        <input
                          placeholder="Search by item code or product name..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleSearch(e);
                            }
                          }}
                          onBlur={handleSearch}
                        />
                        <div
                          className="myshopcart-searchbar-remove_v2"
                          style={{
                            visibility: searchTerm ? "visible" : "hidden",
                            pointerEvents: searchTerm ? "auto" : "none",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setSearchTerm("");
                            setCurrentPage(1);
                            fetchCartData(1, activeTab, "");
                          }}
                        >
                          &#x2715;
                        </div>
                      </div>
                    </div>

                    {loading ? (
                      <div className="loading-container_v2">
                        Loading cart...
                      </div>
                    ) : error ? (
                      <div className="error-container_v2">{error}</div>
                    ) : !loading &&
                      (!cartData?.cart ||
                        (cartData?.cart?.length || 0) === 0) ? (
                      <div className="empty-cart-message_v2">
                        Your cart is empty
                      </div>
                    ) : (
                      <>
                        {/* Modified cart item rendering portion of the component */}
                        {sortCartItems(cartData?.cart || []).map(
                          (item) => (
                            // Hide the main item when its overlay is open
                            // activeOverlayItemId === item.item_id ? null : (
                            <CartItem
                              key={String(item.id)}
                              item={item}
                              selectedItems={selectedItems}
                              handleSelectItem={handleSelectItem}
                              handleEdit={handleEdit}
                              addToWishlist={addToWishlist}
                              formatCurrency={formatCurrency}
                              activeBranchItemId={activeBranchItemId}
                              setActiveBranchItemId={setActiveBranchItemId}
                              activePromoItemId={activePromoItemId}
                              setActivePromoItemId={setActivePromoItemId}
                            />
                          ),
                          // )
                        )}

                        {/* Pagination */}
                        <div className="pagination-modern_v2">
                          <button
                            className="pagination-btn_v2"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            <span className="prevnext-text_v2">Previous</span>
                          </button>
                          {getPagination(currentPage, totalPages).map(
                            (p, idx) =>
                              p === "..." ? (
                                <span
                                  key={`ellipsis-${idx}`}
                                  className="pagination-ellipsis_v2"
                                >
                                  ...
                                </span>
                              ) : (
                                <button
                                  key={`page-${p}-${idx}`}
                                  className={`pagination-btn_v2 ${
                                    currentPage === p
                                      ? " pagination-current_v2"
                                      : ""
                                  }`}
                                  onClick={() => handlePageChange(p)}
                                  disabled={currentPage === p}
                                >
                                  {p}
                                </button>
                              ),
                          )}
                          <button
                            className="pagination-btn_v2"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                          >
                            <span className="prevnext-text_v2">Next</span>
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="myshopcart-right_v2">
                <div className="msc-checkout_v2">
                  <div className="msc-title_v2">Order Summary</div>
                  <div className="msc-totalitem-container_v2">
                    <div className="msc-subtitle_v2">Total item</div>
                    <div className="msc-value-container_v2">
                      {selectedTotals.total_item}
                    </div>
                  </div>
                  <div className="msc-subtotal-container_v2">
                    <div className="msc-subtitle_v2">Subtotal</div>
                    <div className="msc-value-container_v2">
                      <div className="msc-value_v2">
                        <div className="msc-RM_v2">RM</div>
                        <div>{formatCurrency(selectedTotals.subtotal)}</div>
                      </div>
                    </div>
                  </div>
                  {selectedTotals.pwp_amount > 0 && (
                    <div className="msc-subtotal-container_v2">
                      <div className="msc-subtitle_v2">PWP Purchase</div>
                      <div className="msc-value-container_v2">
                        <div className="msc-value_v2">
                          <div className="msc-RM_v2">RM</div>
                          <div>{formatCurrency(selectedTotals.pwp_amount)}</div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="msc-discount-container_v2">
                    <div className="msc-subtitle_v2">Discount</div>
                    <div className="msc-value-container_v2">
                      <div className="msc-value_v2">
                        <div className="msc-RM_v2">- RM</div>
                        <div>
                          {selectedTotals.discount
                            ? formatCurrency(selectedTotals.discount)
                            : "0.00"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="msc-shipfee-container_v2">
                    <div className="msc-subtitle_v2">Delivery Charges</div>
                    <div className="msc-value-container_v2">
                      {selectedTotals.total_shipping_cost === 0 ? (
                        <span style={{ color: "#00a63e" }}>FREE</span>
                      ) : (
                        <div className="msc-value_v2">
                          <div className="msc-RM_v2">RM</div>
                          <div>
                            {formatCurrency(selectedTotals.total_shipping_cost)}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* {selectedTotals.shipping_type === "west_malaysia" &&
                  selectedTotals.free_shipping_gap > 0 ? (
                    <div className="msc-reminder_v2">
                      <Truck size={16} />
                      Add RM {selectedTotals.free_shipping_gap} more for free
                      delivery
                    </div>
                  ) : selectedTotals.shipping_type === "west_malaysia" &&
                    selectedTotals.free_shipping_gap === 0 ? (
                    <div className="msc-reminder_v2 green">
                      <Truck size={16} />
                      You qualify for free delivery!
                    </div>
                  ) : selectedTotals.shipping_type === "east_malaysia" ? (
                    <div className="msc-reminder_v2">
                      <Truck size={16} />
                      Orders under 0.5 CBM are charged as 0.5 CBM
                    </div>
                  ) : (
                    <div className="msc-reminder_v2">
                      <Truck size={16} />
                      Orders above RM 300 qualify for free delivery
                    </div>
                  )} */}

                  <div className="msc-total-container_v2">
                    <div className="msc-subtitle_v2">Total</div>
                    <div className="msc-value-container_v2">
                      <div className="msc-value_v2" style={{ width: "150px" }}>
                        <strong>
                          <div className="msc-RM_v2">RM</div>
                          <div>
                            {selectedTotals.total
                              ? formatCurrency(selectedTotals.total)
                              : "0.00"}
                          </div>
                        </strong>
                      </div>
                    </div>
                  </div>

                  {localStorage.getItem("salesman_id") && (
                    <div
                      className="tocheckout-button-container_v2"
                      style={{ marginBottom: "12px" }}
                    >
                      <div className="tocheckout-button-tooltip_v2">
                        <button
                          className="tocheckout-button_v2 white"
                          onClick={openOrderListPopup}
                          disabled={orderListLoading}
                        >
                          {orderListLoading
                            ? "Loading..."
                            : "Generate Order List"}
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="tocheckout-button-container_v2">
                    <div className="tocheckout-button-tooltip_v2">
                      <button
                        className="tocheckout-button_v2"
                        disabled={
                          selectedItems.length === 0 ||
                          !canCheckout ||
                          selectedTotals.total === 0
                        }
                        onClick={async (e) => {
                          if (!canCheckout) {
                            e.preventDefault();
                            return;
                          }
                          if (selectedItems.length === 0) {
                            e.preventDefault();
                            return;
                          }
                          if (!checkPWPRequirement()) {
                            e.preventDefault();
                            setShowPwpNotice(true);
                            return;
                          }

                          // Call checkFromCart API for each selected item
                          try {
                            let result =
                              await ApiService.checkFromCart(selectedItems);
                            if (result.status === 200) {
                              if (result.data["return_message"] != "") {
                                setReturnMessage(result.data["return_message"]);
                                setShowReturnMessage(true);

                                return;
                              }

                              const totals =
                                await handleGetUnsuccessfulAndOverdueTotal();
                              if (totals?.overdue) {
                                setOverdueMessage(
                                  `Thank you for your order. Our records show an overdue amount of <strong>RM ${totals?.overdue}</strong> on your account. Please make payment as soon as possible to proceed with checkout.`,
                                );
                                setShowOverdueMessage(true);

                                return;
                              }

                              const limits = await handleGetCreditLimit();
                              if (
                                limits !== null &&
                                limits !== "Backend Ignore" &&
                                selectedTotals.total > limits
                              ) {
                                setCreditLimitMessage(
                                  `Hey dear customer,<br>Thank you for placing your order with us.<br>Based on our records, you have exceeded your remaining.<br>You are not allowed to checkout.`,
                                );
                                setShowCreditLimitMessage(true);

                                return;
                              }

                              // param is removed if the itemIds or csIds is missing
                              const itemIds = getSelectedCartIds();
                              const csIds = getSelectedCsIds();
                              const queryParams = new URLSearchParams({
                                pricingtype: activeTab,
                              });

                              let queryString = queryParams.toString();
                              if (itemIds)
                                queryString += `&cart_ids=${itemIds}`;
                              if (csIds) queryString += `&cs_ids=${csIds}`;

                              navigate(`/checkout?${queryString}`);
                            }
                          } catch (error) {
                            console.error("Error checking cart items:", error);
                          }
                        }}
                        style={{
                          opacity:
                            selectedItems.length === 0 || !canCheckout
                              ? 0.5
                              : 1,
                          cursor:
                            selectedItems.length === 0 || !canCheckout
                              ? "not-allowed"
                              : "pointer",
                        }}
                        title={canCheckout ? "" : "No permission"}
                      >
                        Proceed To Checkout <ArrowRight size={20} />
                      </button>
                      {selectedItems.length === 0 && (
                        <span className="tooltip-text_v2">
                          Please select at least one item
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="msc-paymentmethod">
                  Secure Payment
                  <div className="msc-payments">
                    <div className="msc-singlepayment">FPX</div>
                    <div className="msc-singlepayment">IBG</div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div
            style={{
              minHeight: "60vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span style={{ color: "#b71c1c", fontWeight: 600 }}>
              You do not have permission to view this section.
            </span>
          </div>
        )}
      </div>

      {showPwpNotice && (
        <MultiPurpose
          title="Notice"
          message="You have selected a PWP promotion with quantity 0. Do you want to continue without adding any quantity?"
          yesText="Continue"
          noText="No"
          hideNo={false}
          onYes={() => {
            setShowPwpNotice(false);
            navigate(`/checkout?cart_ids=${getSelectedCartIds()}`);
          }}
          onNo={() => setShowPwpNotice(false)}
          onClose={() => setShowPwpNotice(false)}
        />
      )}
      {showReturnMessage && (
        <MultiPurpose
          title={
            returnMessage.includes(
              "Transport charges are not available for the selected branch",
            )
              ? "Transport Charge Not Available"
              : "Cart Check"
          }
          message={returnMessage.replace(/\n/g, "<br>")}
          yesText="Noted"
          hideNo={true}
          useHTML={true}
          onYes={() => setShowReturnMessage(false)}
          onClose={() => setShowReturnMessage(false)}
        />
      )}
      {showOverdueMessage && (
        <MultiPurpose
          title="Payment Required"
          message={overdueMessage}
          yesText="Pay Now"
          hideNo={true}
          useHTML={true}
          onYes={() => setShowOverdueMessage(false)}
          onClose={() => setShowOverdueMessage(false)}
        />
      )}
      {showCreditLimitMessage && (
        <MultiPurpose
          title="Credit Limit"
          message={creditLimitMessage}
          yesText="OK"
          hideNo={true}
          useHTML={true}
          onYes={() => setShowCreditLimitMessage(false)}
          onClose={() => setShowCreditLimitMessage(false)}
        />
      )}
      {notice.show && (
        <MultiPurpose
          title="Notice"
          message={notice.message}
          yesText="OK"
          hideNo={true}
          onYes={() => setNotice({ show: false, message: "" })}
          onClose={() => setNotice({ show: false, message: "" })}
        />
      )}

      {showDeleteItem && (
        <MultiPurpose
          title="Remove Item"
          message={
            <>
              Are you sure you want to remove{" "}
              {Array.isArray(deleteItem) && deleteItem.length > 1
                ? "these items "
                : "this item "}
              from your cart?
              {Array.isArray(deleteItem) &&
                deleteItem.map((i, idx) => (
                  <div key={idx} className="username-highlight">
                    {i.item_code} - {i.item_name}
                  </div>
                ))}
            </>
          }
          yesText={removeLoading ? "Removing..." : "Remove"}
          noText="Cancel"
          onYes={() => handleRemoveItem(deleteItem)}
          onNo={() => setShowDeleteItem(false)}
          onClose={() => setShowDeleteItem(false)}
        />
      )}

      {showEditCart && (
        <EditCart
          onClose={() => {
            setShowEditCart(false);
            setEditCartItem(null);
          }}
          id={editCartItem?.id}
          itemId={editCartItem?.itemId}
          customerId={editCartItem?.customerId}
          quotationId={editCartItem?.quotationId}
          itemQty={editCartItem?.itemQty}
          pricingName={
            pricingTypes?.find((t) => t.pricing_type === activeTab)
              ?.pricing_name || ""
          }
          package_seperate={editCartItem?.package_seperate}
          packing_quantity={editCartItem?.packing_quantity}
          cs_id={editCartItem?.cs_id}
          bundleId={editCartItem?.bundleId || editCartItem?.bundle_id}
          branchRegion={editCartItem?.branch_region}
        />
      )}

      <OrderListPopup />
    </div>
  );
};

export default MyShoppingCartv2;
